const URL_PATH = process.env.REACT_APP_SERVER_URL;

export const loginUser = (email, password) => {
    // Objeto con las credenciales del usuario
    const credentials = {
        mail: email,
        password: password
    };

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
    };

    // Hacer la solicitud al servidor para iniciar sesión
    return fetch(`${URL_PATH}/api/account/login`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log('Login exitoso:', data);// Guardar los datos del usuario en el localStorage
            if(data.codeStatus == 200){
                localStorage.setItem('token', data.token);
            }
            return data;
            // Aquí puedes guardar el token JWT en el sessionStorage o localStorage
        })
        .catch(error => {
            console.error('Error al iniciar sesión:', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const registerUser = (email, password) => {
    // Objeto con las credenciales del usuario
    const credentials = {
        mail: email,
        password: password
    };

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
    };

    // Hacer la solicitud al servidor para registrar usuario
    return fetch(`${URL_PATH}/api/account/register`, requestOptions)
        .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log('Registro exitoso:', data);
            if(data.codeStatus == 200){
                localStorage.setItem('token', data.token);
            }
            return data;
            // Aquí puedes guardar el token JWT en el sessionStorage o localStorage
        })
        .catch(error => {
            console.error('Error al registrar usuario:', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const getCareersByUser = (userId) => {

    const token = localStorage.getItem('token')

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/careers/${userId}`,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const createCareer = (userId,career) => {

    const token = localStorage.getItem('token')
    console.log(token);

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify(career)
    };

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/careers/${userId}`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const saveCareer = (career) => {

    const token = localStorage.getItem('token')

    // Configuración de la solicitud
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify(career)
    };

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/careers/`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const deleteCareer = (careerId) => {

    const token = localStorage.getItem('token')

    // Configuración de la solicitud
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
    };

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/careers/${careerId}`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const forgotPassword = (mail) => {

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            mail: mail
        })
    };

    return fetch(`${URL_PATH}/api/account/forgot-password`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const resetPassword = (newPassword,resetToken) => {

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            newPassword: newPassword,
            resetToken: resetToken
        })
    };

    return fetch(`${URL_PATH}/api/account/restore-password`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const verifyUser = (userId) => {

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };

    return fetch(`${URL_PATH}/api/account/verify/${userId}`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const getOpinions = () => {

    const token = localStorage.getItem('token')

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/opinions/`,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const createOpinion = (opinion,userId) => {

    const token = localStorage.getItem('token')
    console.log(token);

    // Configuración de la solicitud
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify(opinion)
    };

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/opinions/${userId}`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const updateOpinion = (opinion,userId,vote) => {

    const token = localStorage.getItem('token')
    console.log(token);

    // Configuración de la solicitud
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify({...opinion, vote: vote})
    };

    // Hacer la solicitud al servidor para obtener las carreras del usuario
    return fetch(`${URL_PATH}/api/opinions/${userId}`, requestOptions)
    .then(response => response.json())
        .then(data => {
            // Manejar la respuesta del servidor
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('Error: ', error);
            return {status: 'error', statusCode: 504, error: 'Se ha producido un error desconocido. Vuelve a intentar'};
        });
};

export const getTutors = () => {
    const token = localStorage.getItem('token')
    return fetch(`${URL_PATH}/api/tutors/`, {
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
    })
    .then(response => response.json())
    .catch(error => ({ status: 'error', statusCode: 504, error: 'Error desconocido' }));
};

export const getTutorByUser = (userId) => {
    const token = localStorage.getItem('token')
    return fetch(`${URL_PATH}/api/tutors/${userId}`, {
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
    })
    .then(response => response.json())
    .catch(error => ({ status: 'error', statusCode: 504, error: 'Error desconocido' }));
};

export const createTutor = (userId, tutorData) => {
    const token = localStorage.getItem('token')
    return fetch(`${URL_PATH}/api/tutors/${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify(tutorData)
    })
    .then(response => response.json())
    .catch(error => ({ status: 'error', statusCode: 504, error: 'Error desconocido' }));
};

export const updateTutor = (userId, tutorData) => {
    const token = localStorage.getItem('token')
    return fetch(`${URL_PATH}/api/tutors/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify(tutorData)
    })
    .then(response => response.json())
    .catch(error => ({ status: 'error', statusCode: 504, error: 'Error desconocido' }));
};

export const deleteTutor = (userId) => {
    const token = localStorage.getItem('token')
    return fetch(`${URL_PATH}/api/tutors/${userId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': token }
    })
    .then(response => response.json())
    .catch(error => ({ status: 'error', statusCode: 504, error: 'Error desconocido' }));
};

export default { updateOpinion, createOpinion, loginUser, getCareersByUser, registerUser, createCareer, saveCareer, deleteCareer, forgotPassword, resetPassword, verifyUser, getOpinions, getTutors, getTutorByUser, createTutor, updateTutor, deleteTutor };
